import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import FormCheckbox from "../Reusable/CheckBox";
import ComboboxInput from "../Reusable/ComboboxInput";
import NumberField from "../Reusable/NumberField";
import TextAreaField from "../Reusable/TextAreaField";
import TextField from "../Reusable/TextField";
import UnitComboboxInput from "../Reusable/UnitComboboxInput";

const Form = (props: any) => {
  const {
    control,
    register,
    errors,
    watch,
    setValue,
    getValues,
    clearErrors,
    setOpenUnitFormPopup,
    setOpenCategoryFormPopup,
  } = props;
  return (
    <div className={tw`grid grid-cols-2 gap-x-4`}>
      <div>
        <TextField
          control={control}
          name={"name"}
          label={"Product Name"}
          placeholder="Enter Product Name"
        />
        <div
          className={tw`w-full flex mt-3 items-start justify-center space-x-1`}
        >
          <ComboboxInput
            url={APIS.CATEGORY}
            queryKey={"category"}
            register={register("category")}
            errors={errors?.category}
            name={"category"}
            label={"Product Group"}
            setValue={setValue}
            props={{
              is_active: true,
              ordering: "-created",
            }}
            getValues={getValues}
            placeholder={"Search... "}
            clearErrors={clearErrors}
          />
          <button
            className={tw`border px-3 py-1 text-xl leading-0 relative top-7  bg-[#EEF5F4] focus:outline-none`}
            type="button"
            onClick={() => setOpenCategoryFormPopup((prev) => !prev)}
          >
            +
          </button>
        </div>
      </div>
      <TextAreaField
        label="Product Desc."
        control={control}
        rows={5}
        name={"description"}
        placeholder="Write description here..."
      />
      <TextField
        control={control}
        name={"hs_code"}
        label={"HS Code"}
        placeholder="Enter HS Code"
      />
      <div className={tw`w-full flex items-start justify-center space-x-1`}>
        <UnitComboboxInput
          url={APIS.UNIT}
          queryKey={"unit"}
          register={register("unit")}
          errors={errors?.unit}
          name={"unit"}
          label={"Unit"}
          setValue={setValue}
          props={{}}
          getValues={getValues}
          placeholder={"Search... "}
          clearErrors={clearErrors}
        />
        <button
          className={tw`border px-3 py-1 text-xl leading-0 relative top-9  bg-[#EEF5F4] focus:outline-none`}
          type="button"
          onClick={() => setOpenUnitFormPopup((prev) => !prev)}
        >
          +
        </button>
      </div>

      <NumberField
        value={getValues("opening_quantity")}
        register={register("opening_quantity")}
        errors={errors?.opening_quantity}
        label={"Opening Quantity"}
        setValue={setValue}
        clearErrors={clearErrors}
      />
      <NumberField
        value={getValues("opening_rate")}
        register={register("opening_rate")}
        errors={errors?.opening_rate}
        label={"Opening Rate"}
        delimiter=","
        setValue={setValue}
        clearErrors={clearErrors}
      />
      <NumberField
        value={watch("opening_balance")}
        register={register("opening_balance")}
        errors={errors?.opening_balance}
        label={"Opening Value"}
        delimiter=","
        setValue={setValue}
        clearErrors={clearErrors}
      />
      <div className={tw`mt-10`}>
        <FormCheckbox
          name="is_taxable"
          label="Taxable"
          register={register}
          watch={watch}
          setValue={setValue}
        />
      </div>
    </div>
  );
};

export default Form;
